import * as React from 'react'
import * as DateFns from 'date-fns'
import * as d3 from 'd3'
import styled from 'styled-components'
import { useDispatch } from 'redux-react-hook'
// import { Form, Field } from 'react-final-form'
import { Form } from 'react-final-form'
import { Icon } from '../../atoms/icon'
import { StatusIcon } from '../../molecules/status-icon'
import { TotalStatusIcon } from '../../molecules/total-status-icon'
import { Color, Size } from '../../../constants/app.constant'
// import history from '../../utils/history'
import useGetState from '../../../hooks/use-get-state'
import { ResistanceLog } from '../../../interfaces/resistance-log'
import { DayTrainingLog } from '../../../interfaces/day-training-log'
// import { dispAge, calcAge, getWeekCount } from '../report/utils'
import { dispAge, calcAge } from '../report/utils'
import { when } from '../../../utils/mixin'
import { Button, ButtonGroup } from '../../atoms/button'
import { composeValidators, required } from '../../../utils/validator'
import TextFieldItem from '../../molecules/text-field/text-field'
import { setDayReportLogs } from '../../../actions/report.action'
import axios from 'axios'

const { useState, useEffect } = React
export default (param: any) => {
  const dispatch = useDispatch()
  const {
    state: {
      patient,
      report: { reportLog },
    },
  } = useGetState()
  const [node, setNode] = useState<SVGSVGElement>()
  const [modal, setModal] = useState<boolean>(true)
  const [isSuccess, setIsSuccess] = useState<boolean>(true)
  const [localLogs, setLocalLogs] = useState<DayTrainingLog[]>([])
  let defaultWidth = 0
  const defaultHeight = 60
  const colors = [
    Color.STATUS_COLOR.STATUS_1,
    Color.STATUS_COLOR.STATUS_2,
    Color.STATUS_COLOR.STATUS_3,
    Color.STATUS_COLOR.STATUS_4,
  ]
  let isLoading = false
  const onSubmit = async (formValues: any) => {
    const password = formValues.password
    const post = async (password: string) => {
      try {
        const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL)
        const axiosObj = (options?: any) => {
          return axios.create({
            baseURL: API_BASE_URL,
          })
        }
        const response = await axiosObj().post(`shared/${param.param}/get`, {
          password: password,
        })
        if (response && response.data && response.data.patientDayTrainingLogs) {
          setIsSuccess(true)
          dispatch(setDayReportLogs(response.data.patientDayTrainingLogs))
        }
      } catch (e) {
        setIsSuccess(false)
        throw e
      }
    }
    post(password).then(() => {
      isLoading = true
      setModal(false)
    })
  }
  useEffect(
    () => {
      if (reportLog)
        setLocalLogs(
          reportLog.sort(
            (x: DayTrainingLog, y: DayTrainingLog) =>
              new Date(y.startedAt).getTime() -
              new Date(x.startedAt).getTime()
          )
        )
    },
    [reportLog]
  )
  useEffect(
    () => {
      if (reportLog) {
        defaultWidth = reportLog.length * 30
        const resistanceEvaluations = reportLog.map((v: DayTrainingLog) =>
          v.patientDayTrainingResistanceLogs.map((log: ResistanceLog) =>
            Number(log.evaluation)
          )
        )
        const heartRates = reportLog.map((v: DayTrainingLog) =>
          Number(v.evaluation)
        )
        const svg = d3.select(node)
        svg.attr('width', defaultWidth).attr('height', defaultHeight)
        const groups = svg
          .selectAll('g')
          .data(resistanceEvaluations)
          .enter()
          .append('g')
          .attr('id', (d, i) => `id-${i}`)
        groups.each((d: number[], index: number) => {
          d3.select(`#id-${index}`)
            .selectAll('rect')
            .data(d)
            .enter()
            .append('rect')
            .attr('x', () => 24 * index)
            .attr('y', (localD, i) => defaultHeight - 10 * i - 10)
            .attr('height', () => 10)
            .attr('width', 16)
            .attr(
              'style',
              localD =>
                `fill: ${colors[localD - 1]};stroke: ${
                  Color.STATUS_COLOR.STATUS_BORDER
                };`
            )
        })
        const line: any = d3
          .line()
          .x((d, i) => 24 * i)
          .y((d: any, i) => defaultHeight - 10 * d - 10)
        svg
          .append('path')
          .datum(heartRates)
          .attr('d', line)
          .attr('stroke', Color.BLACK)
          .attr('fill', 'none')
      }
    },
    [node]
  )
  return (
    <Wrapper>
      {!isLoading &&
        reportLog && (
          <PageContents>
            <UserDetail>
              <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
              <UserName>
                {patient.username}
              </UserName>
              <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
            </UserDetail>
            <TrainingMetaWrapper>
              <TrainingMetaItem>
                <Lablel>直近の運動開始</Lablel>
                <TrainingMetaBody>
                  {localLogs.length > 0 && 
                    DateFns.format(localLogs[0].startedAt, 'MM月DD日')}
                </TrainingMetaBody>
              </TrainingMetaItem>
              {/*
              <TrainingMetaItem>
                <Lablel>今週の運動目標</Lablel>
                <TrainingMetaBody>
                  あと
                  <Count>3</Count>
                  回
                </TrainingMetaBody>
              </TrainingMetaItem>
              */}
              <TrainingMetaItem>
                <Lablel>過去30日の総合評価</Lablel>
                <TrainingMetaBody>
                  <TotalStatusIcon
                    evaluation={Number(reportLog.latestEvaluationAverage)}
                  />
                </TrainingMetaBody>
              </TrainingMetaItem>
            </TrainingMetaWrapper>
            <TrainingGraphWrapper>
              <Lablel>今月の運動グラフ</Lablel>
              <GraphContents>
                <svg ref={node => setNode(node)} />
              </GraphContents>
            </TrainingGraphWrapper>
            <TrainingListWrapper>
              {localLogs &&
                localLogs.map((v: DayTrainingLog, index: number) => (
                  /*
                <TrainingListItem
                  key={index}
                  onClick={() => history.push(`/report_detail/${v.startedAt}`)}
                >
                */
                  <TrainingListItem key={index}>
                    <TrainingListLeft>
                      <TrainingListLabel>
                        <TrainingCount>
                          {localLogs.length - index}
                        </TrainingCount>
                        回目
                        {/* <Week>{getWeekCount(new Date(v.finishedAt))}</Week> */}
                        <Week>{v.finishedAt ? DateFns.format(v.finishedAt, 'MM/DD') + '終了' : '実施中'}</Week>
                      </TrainingListLabel>
                      <TrainingDate>
                        {DateFns.format(v.startedAt, 'MM月DD日')}
                      </TrainingDate>
                    </TrainingListLeft>
                    <TrainingListRight>
                      <MuscleRate>
                        <Icon.Muscle
                          size={`${Size.LARGE}px`}
                          color={Color.DARK_GRAY}
                        />
                        <StatusList>
                          {v.patientDayTrainingResistanceLogs &&
                            v.patientDayTrainingResistanceLogs.map(
                              (
                                resistanceLog: ResistanceLog,
                                resistanceLogIndex: number
                              ) => (
                                <StatusIcon
                                  key={resistanceLogIndex}
                                  evaluation={Number(resistanceLog.evaluation)}
                                />
                              )
                            )}
                        </StatusList>
                      </MuscleRate>
                      <HeartRate>
                        <Icon.HeartRate
                          size={`${Size.LARGE}px`}
                          color={Color.DARK_GRAY}
                        />
                        <StatusList>
                          {v.aerobicLog && (
                            <StatusIcon
                              evaluation={Number(v.aerobicLog.evaluation)}
                            />
                          )}
                        </StatusList>
                      </HeartRate>
                    </TrainingListRight>
                  </TrainingListItem>
                ))}
            </TrainingListWrapper>
          </PageContents>
        )}
      {modal && (
        <Modal>
          <ModalInner>
            <h2>共有された運動履歴</h2>
            <FormWrapper>
              <Form
                onSubmit={onSubmit}
                validate={(values: any) => {
                  const errors: any = {}
                  errors.password = composeValidators(
                    required('パスワードを入力してください')
                  )(values.password)
                  return errors
                }}
                render={({ handleSubmit, submitting, errors }) => (
                  <form onSubmit={handleSubmit}>
                    <FieldSet>
                      <InvalidMessage>{errors.enable}</InvalidMessage>
                    </FieldSet>
                    <FieldSet>
                      <TextFieldItem
                        name="password"
                        type="text"
                        label="共有されたパスワードを入力"
                        placeholder="password"
                        vertical
                        required={true}
                      />
                    </FieldSet>
                    <FieldSet>
                      <InvalidMessage>
                        {isSuccess ? null : 'パスワードが正しくありません。'}
                      </InvalidMessage>
                    </FieldSet>
                    <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
                      <Button primary>送信</Button>
                    </ButtonGroup>
                  </form>
                )}
              />
            </FormWrapper>
          </ModalInner>
        </Modal>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const UserDetail = styled.div`
  margin: 16px 8px;
  display: flex;
  align-items: center;
  position: relative;
`
const Modal = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index; 10;
`
const ModalInner = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  position: relative;
  background: white;
  height: 100%;
  margin: 0 auto;
  padding: 16px 8px;
  h2 {
    font-size: ${Size.LARGE}px;
    font-weight: normal;
  }
`
const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`
const InvalidMessage = styled.p`
  color: ${Color.STATUS_COLOR.STATUS_1};
  margin-top: 10px;
  font-size: ${Size.FONT.SMALL}px;
`
const FormWrapper = styled.div`
  padding: 28px 0;
`
const FieldSet = styled.div<{
  vertical?: boolean
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  div {
    width: 100%;
  }
  ${when('vertical')(`
    flex-direction: column;
    align-items: start;
  `)};
`
const TrainingMetaWrapper = styled.div`
  display: flex;
  align-items: end;
  margin: 8px;
  justify-content: space-between;
`
const TrainingMetaItem = styled.div`
  display: flex;
  flex-direction: column;
`
const Lablel = styled.div`
  font-size: ${Size.BASE}px;
  color: ${Color.VERY_LIGHT_GRAY};
  margin-bottom: 8px;
  font-weight: ${Size.FONT_WEIGHT.NORMAL};
`
const TrainingMetaBody = styled.div`
  font-size: ${Size.LARGE}px;
  display: flex;
  align-items: baseline;
  font-weight: ${Size.FONT_WEIGHT.THIN};
`
/*
const Count = styled.div`
  font-size: ${Size.LARGE}px;
  margin: 0 4px;
  font-weight: ${Size.FONT_WEIGHT.BOLD};
`
*/
const TrainingGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
`
const GraphContents = styled.div`
  border-bottom: solid 1px ${Color.VERY_LIGHT_GRAY};
  width: 100%;
  overflow-x: scroll;
  svg {
    .y_axis {
      path.domain {
        stroke: white;
      }
      line {
        stroke: ${Color.STATUS_COLOR.STATUS_BORDER};
      }
    }
  }
`
const TrainingListWrapper = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
`
const TrainingListItem = styled.div`
  display: flex;
  padding: 12px;
  background: ${Color.BG_GRADIENT_0};
  cursor: pointer;
`
const TrainingListLeft = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  min-width: 95px;
`
const TrainingListRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`
const TrainingListLabel = styled.div`
  font-size: ${Size.BASE}px;
  color: ${Color.VERY_LIGHT_GRAY};
  font-weight: ${Size.FONT_WEIGHT.NORMAL};
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
`
const TrainingDate = styled.div`
  font-size: ${Size.XLARGE}px;
  color: ${Color.BLACK};
  font-weight: ${Size.FONT_WEIGHT.THIN};
`
const TrainingCount = styled.div`
  font-size: ${Size.MIDDLE2}px;
  color: ${Color.VERY_LIGHT_GRAY};
`
const Week = styled.div`
  color: ${Color.VERY_LIGHT_GRAY};
  margin-left: 8px;
`

const MuscleRate = styled.div`
  display: flex;
`
const HeartRate = styled.div`
  display: flex;
`

const StatusList = styled.div`
  margin-left: 8px;
  span {
    margin-right: 4px;
  }
`



// WEBPACK FOOTER //
// ./src/components/pages/share/contents.tsx